import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { apiPrefix } from 'constants/apiConfig';

type DateTimeType = {
  utc: () => DateTimeType;
  subtract: (value: number, field: string) => DateTimeType;
  set: (field: string, value: number) => DateTimeType;
  format: (formatString: string) => string;
};

type SilurianFeatureType = {
  type: string;
  geojson: string; // Assuming this is a GeoJSON string
  model_datetime: string; // ISO 8601 date string
  storm_id_dt: string; // Assuming this is a string identifier for the storm
};

export const useSilurianProjectionLayer = () => {
  return useMutation({
    mutationFn: async (selectedDateTime: DateTimeType) => {
      const formattedDatetime = selectedDateTime
        .set('minutes', 0)
        .set('seconds', 0)
        .format('YYYY-MM-DD HH:mm:ss');

      const { data } = await axios(`${apiPrefix}/dice/map/silurianHurricanes`, {
        method: 'GET',
        params: {
          selectedDatetime: formattedDatetime,
        },
      });

      // Remove duplicates.
      // Note that this should reallly be done in the backend
      const uniqueSilurianData = data.reduce(
        (acc: SilurianFeatureType[], feature: SilurianFeatureType) => {
          if (
            !acc.some((item) => {
              return (
                item.type === feature.type &&
                item.geojson === feature.geojson &&
                item.model_datetime === feature.model_datetime &&
                item.storm_id_dt === feature.storm_id_dt
              );
            })
          ) {
            acc.push(feature);
          }
          return acc;
        },
        []
      );

      return uniqueSilurianData;
    },
  });
};

export default useSilurianProjectionLayer;
